export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=5ef9aa1a"


//////////////////
// WEBPACK FOOTER
// ./src/components/payment-system/index.vue?vue&type=template&id=5ef9aa1a
// module id = v4tB
// module chunks = 0